import styled from 'styled-components';

import { progressiveBackground } from '@r1-frontend/ui-react/components/helpers/image';
import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Header = styled.section<{ backgroundImage: string, backgroundImageWebp: string }>`
    width: 100%;
    height: 614px;
    ${({ backgroundImage, backgroundImageWebp }) => progressiveBackground({
        src: backgroundImage,
        webpSrc: backgroundImageWebp,
    })};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    @media (max-width: ${wideBreakpoints.laptop}) {
        height: 460px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: 364px;
        background-position: top;
    }
`;

export const Container = styled(WideContainer)`
    position: relative;
    padding-top: 130px;
    justify-content: center;
    text-align: center;
`;

export const AgeRating = styled.p`
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 16px;
    ${FONTS.L};

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-right: 16px;
    }
`;
